import {
	DEBUG_PARAMS,
	isDebugParamEnabled,
} from '@dealstack/frontend/shared/mechanism/debugging/util';
import { ENVIRONMENT_CATEGORY } from '@dealstack/shared/lib/common/environment';

/* eslint-disable no-console */
enum LOG_LEVEL {
	'ERROR' = 'error',
	'DEBUG' = 'debug',
	'TRACE' = 'trace',
	'WARN' = 'warn',
	'INFO' = 'info',
}

interface loggerConfig {
	enviroment?: ENVIRONMENT_CATEGORY;
}

class Logger {
	private isProduction = true;

	setConfig(config: loggerConfig) {
		this.isProduction = config.enviroment === ENVIRONMENT_CATEGORY.PRODUCTION;
	}

	[LOG_LEVEL.ERROR](message?: unknown, ...optionalParams: unknown[]) {
		console.error('[ERROR]', message, ...optionalParams);
	}

	[LOG_LEVEL.DEBUG](message?: unknown) {
		if (!isDebugParamEnabled(DEBUG_PARAMS.ENABLE_DEBUG_LOGS)) {
			return;
		}
		console.log(`%c[DEBUG] ${message}`, 'color:red;font-family:system-ui;font-size:1rem;');
	}

	[LOG_LEVEL.TRACE](message?: unknown, ...optionalParams: unknown[]) {
		console.trace('[TRACE]', message, ...optionalParams);
	}

	[LOG_LEVEL.WARN](message?: unknown, ...optionalParams: unknown[]) {
		if (this.isProduction) {
			return;
		}
		console.warn('[WARN]', message, ...optionalParams);
	}

	[LOG_LEVEL.INFO](message?: unknown, ...optionalParams: unknown[]) {
		console.info('[INFO]', message, ...optionalParams);
	}
}

export const logger = new Logger();
